// The remembered theme choice on the web (FR-022; research R8; data-model §7). `localStorage` is
// synchronous, so the preference is known before the first render. The inline script in
// public/index.html reads the same key before the bundle loads (no theme flash, R6).
import { parseThemePreference, THEME_STORAGE_KEY } from "./themePreference";
import type { ThemePreference } from "./theme";

export function readThemePreference(): ThemePreference {
  try {
    return parseThemePreference(
      globalThis.localStorage.getItem(THEME_STORAGE_KEY),
    );
  } catch {
    return "system";
  }
}

export function writeThemePreference(preference: ThemePreference): void {
  try {
    globalThis.localStorage.setItem(THEME_STORAGE_KEY, preference);
  } catch {
    // Blocked storage: the choice still applies for this session.
  }
}
